import { render, staticRenderFns } from "./StorageSpacesMedia.vue?vue&type=template&id=962104b8&"
import script from "./StorageSpacesMedia.vue?vue&type=script&lang=js&"
export * from "./StorageSpacesMedia.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports